export const getShadowDocument = () =>
  document?.getElementsByTagName('sync-module-content-web-component')?.[0]?.shadowRoot || document;

const getRootServerRoot = () => document.querySelector('[data-id="micro-fe-root"]');

export const getMicroFeContainer = () =>
  document
    ?.getElementsByTagName('sync-module-content-web-component')?.[0]
    ?.shadowRoot?.getElementById('micro-fe-app') || getRootServerRoot();

export const dispatchMicroFeLoadedEvent = () => {
  const customEvent = new CustomEvent('sync_module_content_web_component_loaded');
  document.dispatchEvent(customEvent);
};

export const hideOverflowOnMicroFeContainer = () => {
  const container = document.getElementById('sync-module-content-web-component');
  if (container) container.style.overflow = 'hidden';
};

export const renderingInMicroFE = !!getRootServerRoot();
